export const ExchangePage = () => {
  return <div>Exchange Page</div>;
};
